import { InfoCard } from "../../UnitPanel/components/common/InfoCard"
import { NodeAttrEditor } from "../NodeAttrEditor"
import { MMNumberEditor } from "./MMNumberEditor"
import { Node } from "@antv/x6"

interface LineJumpEditorProps {
  node: Node
}

export function LineJumpEditor(props: LineJumpEditorProps) {
  const {node} = props
  const angle = Math.round(node.getAngle());
  const size = node.getSize()

  let showWidth = true
  if (angle % 180 !== 0 && angle % 90 === 0) {
    showWidth = false
  }

  let label = 'Width'
  const value = size.width
  if (!showWidth) {
    label = 'Height'
  }

  return <>
    <InfoCard title='Size' className="mt-1">
      <NodeAttrEditor
        attrPath="size/width"
        node={node} Editor={MMNumberEditor} label={label} initValue={value} />
    </InfoCard>
  </>
}